'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return typeof window !== 'undefined';
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@sketchpixy/rubix/lib/isBrowser.js
// module id = 114
// module chunks = 81